import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem, fonts, metrics } from '../../__styling'
import { IconCross } from '../../navigation/TNFlyoutNav/assets/IconCross'

const { utility, white } = tokens.thenightly.colors.palette
const { sm, sm2l, m2l, xxxl } = metrics.thenightly.margins
const { sansSerif } = fonts.thenightly

interface StyledTNSlideToastProps {
    type?: 'success' | 'error'
    show?: boolean
    forceRender?: boolean
}

export const StyledTNSlideToast = styled('div')<StyledTNSlideToastProps>(
    ({ show = false, type = 'success', forceRender = false }) => ({
        position: forceRender ? undefined : 'relative',

        width: '100%',
        bottom: show ? calcRem(xxxl) : calcRem(-xxxl),
        padding: calcRem(0, m2l),
        transition: forceRender ? undefined : 'all 0.3s',
        opacity: show ? 1 : 0,
        div: {
            display: 'flex',
            alignItems: 'center',
            background:
                type === 'success'
                    ? utility.success.dark
                    : utility.error.default,
            borderRadius: '8px',
            padding: calcRem(sm2l),
            color: white,
            fontWeight: 600,
            span: {
                marginLeft: calcRem(sm),
            },
        },
        [breakpoint('sm')]: {
            width: calcRem(400),
            padding: 0,
            left: '50%',
            transform: 'translateX(-50%)',
        },
    }),
)

export const StyledIconCross = styled(IconCross)<{ onClick: () => void }>({
    height: calcRem(24),
    width: calcRem(24),
    fill: white,
    '&:hover': {
        cursor: 'pointer',
    },
    marginLeft: 'auto',
})
